import { gql } from '@apollo/client';

const getAllMcpKeys = gql`
  query GetAllMcpKeys {
    getAllMcpKeys {
      id
      key_prefix
      label
      scopes
      expires_at
      revoked_at
      last_used_at
      createdAt
      userId
      username
    }
  }
`;

export default getAllMcpKeys;
